import React from "react";
import "./Hero.scss";
import { Box, Flex, Text, Button } from "@chakra-ui/react";
import { Carousel } from "react-bootstrap";

export const Hero = () => {
  return (
    <div>
      <Carousel>
        <Carousel.Item>
          <img
            className="hero d-block w-100"
            src="/images/slide1.png"
            alt="First slide"
          />
          <Carousel.Caption>
            <Flex direction="column" justify="start" marginRight="0px">
              <Box>
                <Text
                  fontSize={{ base: "14px", md: "24px", lg: "50px" }}
                  fontStyle="normal"
                  fontWeight="bold"
                  fontFamily="Circular Std, sans-serif"
                  color="#fff"
                >
                  Learning and <br />
                  Development
                </Text>
              </Box>
              <Box
                marginBottom={{
                  base: "20px",
                  md: "150px",
                  lg: "200px",
                  xl: "350px",
                }}
              >
                <Button
                  height="48px"
                  width={{ base: "200px", md: "300px", lg: "300px" }}
                  background="#00a2e8"
                  border="1px solid #00a2e8"
                  borderRadius="4px"
                  color="#fff"
                  fontFamily="Circular Std, sans-serif"
                  fontWeight="400"
                  fontSize={{ base: "14px", md: "24px", lg: "24px" }}
                  fontStyle="normal"
                  className="cta"
                  mt="1rem"
                >
                  Learnerkia for Business
                </Button>
              </Box>
            </Flex>
          </Carousel.Caption>
        </Carousel.Item>
        <Carousel.Item>
          <img
            className="hero d-block w-100"
            src="/images/slide2.png"
            alt="Third slide"
          />

          <Carousel.Caption>
            <Flex direction="column" justify="start">
              <Box>
                <Text
                  fontSize={{ base: "14px", md: "24px", lg: "50px" }}
                  fontStyle="normal"
                  fontWeight="bold"
                  fontFamily="Circular Std, sans-serif"
                  color="#fff"
                >
                  Learning Management <br /> System
                </Text>
              </Box>
              <Box
                marginBottom={{
                  base: "20px",
                  md: "150px",
                  lg: "200px",
                  xl: "350px",
                }}
              >
                <Button
                  height="48px"
                  width={{ base: "200px", md: "300px", lg: "300px" }}
                  background="#00a2e8"
                  border="1px solid #00a2e8"
                  borderRadius="4px"
                  color="#fff"
                  fontFamily="Circular Std, sans-serif"
                  fontWeight="400"
                  fontSize={{ base: "14px", md: "24px", lg: "24px" }}
                  fontStyle="normal"
                  className="cta"
                >
                  Learnerkia for Business
                </Button>
              </Box>
            </Flex>
          </Carousel.Caption>
        </Carousel.Item>
        <Carousel.Item>
          <img
            className="hero d-block w-100"
            src="/images/slide3.png"
            alt="Third slide"
          />

          <Carousel.Caption>
            <Flex direction="column" justify="start">
              <Box>
                <Text
                  fontSize={{ base: "14px", md: "24px", lg: "50px" }}
                  fontStyle="normal"
                  fontWeight="bold"
                  fontFamily="Circular Std, sans-serif"
                  color="#fff"
                >
                  Learn from <br />
                  Anywhere
                </Text>
              </Box>
              <Box
                marginBottom={{
                  base: "20px",
                  md: "150px",
                  lg: "200px",
                  xl: "350px",
                }}
              >
                <Button
                  height="48px"
                  width={{ base: "200px", md: "300px", lg: "300px" }}
                  background="#00a2e8"
                  border="1px solid #00a2e8"
                  borderRadius="4px"
                  color="#fff"
                  fontFamily="Circular Std, sans-serif"
                  fontWeight="400"
                  fontSize={{ base: "14px", md: "24px", lg: "24px" }}
                  fontStyle="normal"
                  className="cta"
                >
                  Learnerkia for Business
                </Button>
              </Box>
            </Flex>
          </Carousel.Caption>
        </Carousel.Item>
      </Carousel>
    </div>
  );
};

export default Hero;
